<template>
  <main id="main_authors">
    <span v-ornament></span>
    <h1>autorias</h1>
    <div>
      <article v-for="author in authors">
        <figure>
          <a @click="searchAuthor(author.slug)">
            <img src=" data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw== ":style="author.user_meta[7] | formatImg" />
          </a>
          <figcaption>
            <h2>{{author.name}}</h2>
          </figcaption>
        </figure>
        <hr />
        <!-- <p>{{author.description}}</p> -->
        <ul class="social">
            <li v-if="author.user_meta[3]"><a :href="'http://facebook.com/'+formatSocial(author.user_meta[3])" v-linkout title="Facebook"><svg viewBox="0 0 512 512"><circle class="svg_out" /><path d="M211.9 197.4h-36.7v59.9h36.7V433.1h70.5V256.5h49.2l5.2-59.1h-54.4c0 0 0-22.1 0-33.7 0-13.9 2.8-19.5 16.3-19.5 10.9 0 38.2 0 38.2 0V82.9c0 0-40.2 0-48.8 0 -52.5 0-76.1 23.1-76.1 67.3C211.9 188.8 211.9 197.4 211.9 197.4z"/></svg></a></li>
            <li v-if="author.user_meta[5]"><a :href="'http://flickr.com/phots/'+formatSocial(author.user_meta[5])" title="Flickr"><svg viewBox="0 0 512 512"><circle class="svg_out" /><path d="M344.5 156.9c-38.7 0-72.1 22.1-88.5 54.4 -16.4-32.3-49.8-54.4-88.5-54.4 -54.8 0-99.1 44.4-99.1 99.1 0 54.8 44.4 99.1 99.1 99.1 38.6 0 72.1-22.1 88.5-54.4 16.4 32.3 49.8 54.4 88.5 54.4 54.8 0 99.1-44.4 99.1-99.1C443.6 201.2 399.2 156.9 344.5 156.9zM344.5 328.7c-40.1 0-72.7-32.6-72.7-72.7s32.6-72.7 72.7-72.7 72.7 32.6 72.7 72.7C417.2 296.1 384.6 328.7 344.5 328.7z"/></svg><!--[if lt IE 9]><em>Flickr</em><![endif]--></a></li>
            <!-- <li><a href="http://instagram.com/bruno.is" v-linkout title="Instagram"><svg viewBox="0 0 512 512"><circle class="svg_out" /><g><path d="M256 109.3c47.8 0 53.4 0.2 72.3 1 17.4 0.8 26.9 3.7 33.2 6.2 8.4 3.2 14.3 7.1 20.6 13.4 6.3 6.3 10.1 12.2 13.4 20.6 2.5 6.3 5.4 15.8 6.2 33.2 0.9 18.9 1 24.5 1 72.3s-0.2 53.4-1 72.3c-0.8 17.4-3.7 26.9-6.2 33.2 -3.2 8.4-7.1 14.3-13.4 20.6 -6.3 6.3-12.2 10.1-20.6 13.4 -6.3 2.5-15.8 5.4-33.2 6.2 -18.9 0.9-24.5 1-72.3 1s-53.4-0.2-72.3-1c-17.4-0.8-26.9-3.7-33.2-6.2 -8.4-3.2-14.3-7.1-20.6-13.4 -6.3-6.3-10.1-12.2-13.4-20.6 -2.5-6.3-5.4-15.8-6.2-33.2 -0.9-18.9-1-24.5-1-72.3s0.2-53.4 1-72.3c0.8-17.4 3.7-26.9 6.2-33.2 3.2-8.4 7.1-14.3 13.4-20.6 6.3-6.3 12.2-10.1 20.6-13.4 6.3-2.5 15.8-5.4 33.2-6.2C202.6 109.5 208.2 109.3 256 109.3M256 77.1c-48.6 0-54.7 0.2-73.8 1.1 -19 0.9-32.1 3.9-43.4 8.3 -11.8 4.6-21.7 10.7-31.7 20.6 -9.9 9.9-16.1 19.9-20.6 31.7 -4.4 11.4-7.4 24.4-8.3 43.4 -0.9 19.1-1.1 25.2-1.1 73.8 0 48.6 0.2 54.7 1.1 73.8 0.9 19 3.9 32.1 8.3 43.4 4.6 11.8 10.7 21.7 20.6 31.7 9.9 9.9 19.9 16.1 31.7 20.6 11.4 4.4 24.4 7.4 43.4 8.3 19.1 0.9 25.2 1.1 73.8 1.1s54.7-0.2 73.8-1.1c19-0.9 32.1-3.9 43.4-8.3 11.8-4.6 21.7-10.7 31.7-20.6 9.9-9.9 16.1-19.9 20.6-31.7 4.4-11.4 7.4-24.4 8.3-43.4 0.9-19.1 1.1-25.2 1.1-73.8s-0.2-54.7-1.1-73.8c-0.9-19-3.9-32.1-8.3-43.4 -4.6-11.8-10.7-21.7-20.6-31.7 -9.9-9.9-19.9-16.1-31.7-20.6 -11.4-4.4-24.4-7.4-43.4-8.3C310.7 77.3 304.6 77.1 256 77.1L256 77.1z"/><path d="M256 164.1c-50.7 0-91.9 41.1-91.9 91.9s41.1 91.9 91.9 91.9 91.9-41.1 91.9-91.9S306.7 164.1 256 164.1zM256 315.6c-32.9 0-59.6-26.7-59.6-59.6s26.7-59.6 59.6-59.6 59.6 26.7 59.6 59.6S288.9 315.6 256 315.6z"/><circle cx="351.5" cy="160.5" r="21.5"/></g></svg></a></li> -->
            <li v-if="author.user_meta[6]"><a :href="'http://lastfm.com/user/'+formatSocial(author.user_meta[6])" v-linkout title="Last.fm"><svg viewBox="0 0 512 512"><circle class="svg_out" /><path d="M230.104 336.568l-13.607-36.988c0 0-22.11 24.66-55.268 24.66 -29.341 0-50.172-25.512-50.172-66.328 0-52.293 26.359-71.001 52.297-71.001 37.412 0 49.316 24.234 59.522 55.273l13.607 42.518c13.603 41.236 39.113 74.402 112.666 74.402 52.727 0 88.437-16.155 88.437-58.672 0-34.438-19.56-52.297-56.125-60.802l-27.209-5.951c-18.707-4.252-24.233-11.906-24.233-24.659 0-14.456 11.478-22.96 30.189-22.96 20.406 0 31.458 7.653 33.162 25.935l42.516-5.103c-3.402-38.263-29.761-53.996-73.127-53.996 -38.266 0-75.68 14.456-75.68 60.799 0 28.912 14.029 47.197 49.315 55.697l28.916 6.801c21.683 5.104 28.908 14.031 28.908 26.363 0 15.73-15.305 22.107-44.218 22.107 -42.941 0-60.794-22.534-70.999-53.574l-14.032-42.513c-17.854-55.271-46.342-75.68-102.892-75.68 -62.499-0.001-95.663 39.538-95.663 106.715 0 64.628 33.164 99.489 92.689 99.489C207.141 359.1 230.104 336.568 230.104 336.568L230.104 336.568z"/></svg><!--[if lt IE 9]><em>Last.fm</em><![endif]--></a></li>

        </ul>
        <!-- url {{author.user_meta[2] | formatSocial}}<br />
        fb {{author.user_meta[3] | formatSocial}}<br />
        twitter {{author.user_meta[4] | formatSocial}}<br />
        flickr {{author.user_meta[5] | formatSocial}}<br />
        lastfm {{author.user_meta[6] | formatSocial}}<br /> -->
      </article>
    </div>
    <span v-ornament></span>
  </main>
</template>

<script>
import Axios from 'axios';
export default {
  data () {
    return {
      authors: {}
    }
  },
  computed: {

  },
  mounted() {
    var promise = new Promise((resolve,reject)=>{
      Axios.get('http://ecos.ec/wp-json/wp/v2/users/').then(res=>{
        res.data.shift();
        this.authors = res.data;
        this.$store.commit('setPostsSelected',null);
        this.$store.commit('setPagesCurr',false);
        this.$store.commit('clearSearch');
        resolve(true);
      });
    });
    this.loader(promise,"#main_authors")
  },
  methods: {
    searchAuthor(slug) {
      this.$store.dispatch('setSearch','autor:'+slug);
    },
    formatSocial(str) {
      str = str.split('/');
      return str.pop();
    }
  }
}
</script>

<style scoped>
h1 {
  font-weight: bold;
  font-size: 2em;
  line-height: 10px;
  margin-bottom: 30px;
  text-align: center;
  padding: 0;
  text-transform: uppercase
}
main {
  padding: 2em 1em;
  max-width: 540px;
  margin: 0 auto;
  width: 100%;
}
main>div {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 10px;
}
article h2{
  font-size: 1.5em;
  display: block;
  margin: 5px 0;
}
article>figure {
  text-align: center;
}
article>figure img {
  width: 100%;
  max-width: 85px;
  background-size: contain;
  border-radius: 50%;
  border: 1px solid rgb(var(--dgray));
}
article ul {
  text-align: center;
  margin-left: -3px;
}
article li {
  display: inline;
}
svg {
  margin-right: 0 3px;
  width: 20px;
  height: 20px;
  background-color: rgb(var(--red));
  border-radius: 50%;

  /*fill: rgb(var(--red));*/
  fill: rgb(var(--lgray));
  width: 20px;
}

article>div {
  display: flex;
  width: auto;
  flex-wrap: wrap;
  align-items: start;
  padding: 0 2em
}
</style>



// WEBPACK FOOTER //
// src/components/Authors.vue